module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 8.a60ee6e7.png";